import styled from "styled-components";

export const SignInContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    position: relative;
    width: 100%;
    max-width: 480px;
    
    .critical-message-container {
        width: 100%;
    }

    .error {
        color: #FFFFFF;
        font-weight: 600;
        text-align: center;
    }
`
export const ForgotPasswordBtn = styled.h3`
    box-sizing: border-box;
    color: rgba(255,255,255,0.75);
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    padding: 8px;
    padding-top: 0px;
    text-align: center;
    text-decoration: underline;
    transition: 0.3s ease-in-out;
    width: 100%;

    bottom: -24px;
    left: 0;
    position: absolute;

    &:hover {
        color: rgba(255,255,255,1);
        transform: scale(1.015);
    }
`
